import { createPerformanceContributorsQuery } from "./performance"
import { createDrilldownBaseGatherers, type DrilldownBaseGathererOptions } from "./drilldown-base"
import type { ContributorsQueryOptions } from "./contributors-query-types"

export function createDrilldownPerformanceContributorsQuery(options: ContributorsQueryOptions) {
  // Performance contributor values use summary/category-aggregate keys ("total", category ids)
  // as well as individual factor keys — filterNodeToFactors would drop the summary keys.
  // createPerformanceContributorsQuery also never reads the `category` option, so there is
  // nothing to gain from client-side post-filtering; pass options through unchanged.
  return createPerformanceContributorsQuery(options)
}

export function createPerformanceDrilldownGatherers({
  endDate,
  startDate,
  selectedFactor,
  selectedCategory,
  classifications,
  isRfrAttributionEnabled,
  instrumentSuffix = "",
  ...coreOptions
}: DrilldownBaseGathererOptions & {
  selectedFactor?: string
  selectedCategory?: string
  isRfrAttributionEnabled?: boolean
}) {
  const baseGatherers = createDrilldownBaseGatherers({
    ...coreOptions,
    endDate,
    startDate,
    classifications,
    excludePerformance: true,
    instrumentSuffix,
  })
  const performanceGatherer = createDrilldownPerformanceContributorsQuery({
    ...coreOptions,
    prefix: `performance${instrumentSuffix}`,
    from: startDate,
    to: endDate,
    selectedFactor,
    selectedCategory,
    isRfrAttributionEnabled,
  })
  return [...baseGatherers, performanceGatherer]
}
